import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../../shared/validators/DbValidators";

@Component({
    selector: 'db-ai-builder-create-page-blank',
    templateUrl: './ai-builder-create-page-blank.component.html',
    styleUrls: ['./ai-builder-create-page-blank.component.scss'],
    standalone: false
})
export class AiBuilderCreatePageBlankComponent {

  public arrowHidden: boolean = false;
  @Output() onBack: EventEmitter<void> = new EventEmitter<void>();
  @Output() onAddPage: EventEmitter<string> = new EventEmitter<string>();
  @Output() showUpgradePopup: EventEmitter<string> = new EventEmitter<string>();
  @Input() demoUser?: boolean;
  public pageTitle: FormControl = new FormControl('', [DbValidators.trimStart, Validators.required]);
  public loading: boolean = false;
  public isMobile: boolean = window.innerWidth <= 991;

  public addPage(): void {
    if (this.pageTitle.invalid) return;
    if (this.demoUser) return this.showUpgradePopup.emit('Blank');
    this.loading = true;
    this.arrowHidden = true;
    this.onAddPage.emit(this.pageTitle.value);
  }

}
